import React from "react";

interface LocationPinIconProps {
  className?: string;
}

const LocationPinIcon = ({ className }: LocationPinIconProps) => (
  <svg
    width="28"
    height="36"
    viewBox="0 0 28 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M14 0C6.268 0 0 6.268 0 14C0 24.5 14 36 14 36C14 36 28 24.5 28 14C28 6.268 21.732 0 14 0Z"
      fill="var(--blue-500)"
    />
    <circle cx="14" cy="14" r="5" fill="white" />
  </svg>
);

export default LocationPinIcon;
